import '../styles/DashboardHubMasthead.css';
import React from 'react';

function DashboardHubMasthead() {
  return (
    <section
      className="dhm-section"
      aria-labelledby="dhm-heading"
      data-content-rail="workspace"
    >
      <div className="dhm-rail">
        <div className="dhm-band">
          <div className="dhm-identity">
            <span className="dhm-eyebrow">Brute · Operator console</span>
            <h1 id="dhm-heading" className="dhm-heading">
              Operator<br />
              <span className="dhm-heading__accent">Hub</span>
            </h1>
            <p className="dhm-subline">
              Recent runs, live monitors and results in one place.
            </p>
          </div>

          <div className="dhm-actions">
            <span className="dhm-sticker">
              <span className="dhm-sticker__dot" aria-hidden="true" />
              Authorized target only
            </span>

            <div className="dhm-cta-row">
              <a className="dhm-cta" href="/new-test-run">
                New test run
                <span className="dhm-cta__arrow" aria-hidden="true">→</span>
              </a>
              <a className="dhm-secondary" href="/history">
                Open History
                <span className="dhm-secondary__arrow" aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DashboardHubMasthead;